import BagIcon from "@svg/new-design/bag";
import SmilingIcon from "@svg/new-design/smiling";
import { EnglishFormal } from "../../../../layout/modal/certificate/certificateRecommendedDate/english-formal";
import { EnglishInformalWithEmoji } from "../../../../layout/modal/certificate/certificateRecommendedDate/english-informal-withEmoji";
import { EnglishInformalWithOutEmoji } from "../../../../layout/modal/certificate/certificateRecommendedDate/english-informal-withoutEmoji";
import { PersianFormal } from "../../../../layout/modal/certificate/certificateRecommendedDate/persian-formal";
import { PersianInformalWithEmoji } from "../../../../layout/modal/certificate/certificateRecommendedDate/persian-informal-withEmoji";
import { PersianInformalWithoutEmoji } from "../../../../layout/modal/certificate/certificateRecommendedDate/persian-informal-withoutEmoji";
import { persianFormalWithEmoji } from "../../../../layout/modal/certificate/certificateRecommendedDate/persian-formal-withEmoji";
import UserStarIcon from "@svg/new-design/user-star";
import UserAscentIcon from "@svg/new-design/user-ascent";
import {
  CERTIFICATE_DETAIl,
  CERTIFICATE_LANG,
  CERTIFICATE_TONE,
} from "enums/certificate";
export const toneList = [
  {
    name: "رسمی",
    id: CERTIFICATE_TONE.FORMAL,
    icon: BagIcon,
  },
  {
    name: "غیررسمی",
    id: CERTIFICATE_TONE.INFORMAL,
    icon: SmilingIcon,
  },
];

export const recommendedList = {
  [CERTIFICATE_LANG.FA]: {
    [CERTIFICATE_TONE.FORMAL]: {
      [CERTIFICATE_DETAIl.WITH_EMOJI]: persianFormalWithEmoji,
      "": PersianFormal,
    },
    [CERTIFICATE_TONE.INFORMAL]: {
      [CERTIFICATE_DETAIl.WITH_EMOJI]: PersianInformalWithEmoji,
      "": PersianInformalWithoutEmoji,
    },
  },
  [CERTIFICATE_LANG.EN]: {
    [CERTIFICATE_TONE.FORMAL]: {
      [CERTIFICATE_DETAIl.WITH_EMOJI]: EnglishInformalWithEmoji,
      "": EnglishFormal,
    },
    [CERTIFICATE_TONE.INFORMAL]: {
      [CERTIFICATE_DETAIl.WITH_EMOJI]: EnglishInformalWithEmoji,
      "": EnglishInformalWithOutEmoji,
    },
  },
};
export const langList = [
  {
    name: "انگلیسی",
    id: CERTIFICATE_LANG.EN,
  },
  {
    name: "فارسی",
    id: CERTIFICATE_LANG.FA,
  },
];

export const detailList = [
  {
    title: "عنوان آموزش",
    id: CERTIFICATE_DETAIl.WITH_COURSE_TITLE,
    name: "title",
  },
  {
    title: "ایموجی",
    id: CERTIFICATE_DETAIl.WITH_EMOJI,
    name: "emoji",
  },
];

export const linkedinFeatureItem = [
  {
    icon: UserStarIcon,
    title: "تقویت پروفایل لینکدین",
    description: "با نمایش مهارت‌ها و دستاوردهای آموزشی",
  },
  {
    icon: UserAscentIcon,
    title: "افزایش اعتبار حرفه‌ای",
    description: "در بین شبکه ارتباطی و همکاران خود",
  },
  {
    icon: BagIcon,
    title: "افزایش شانس استخدام",
    description: "شانس دیده شدن بیشتر در نتایج جستجو",
  },
];
